import '~/assets/sass/styles.sass'
import '~/assets/sass/general.sass'
import '~/assets/css/global.css'

export const onRouteUpdate = () => {
  // HubSpot chat targeting updates only on page load, so refresh on SPA navigation
  setTimeout(() => {
    if (window.HubSpotConversations?.widget) {
      window.HubSpotConversations.widget.refresh();
    } else {
      // if hubspot loads late
      window.HubSpotConversations?.widget?.load?.();
    }
  }, 300);
};